






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { ServingNutritionDto, ServingNutritionType } from '@/api';
import { TranslateResult } from 'vue-i18n';
import NutritionRow from '@/views/product/nutrition/NutritionRow.vue';

@Component({
    components: {NutritionRow},
  },
)
export default class NutritionTable extends Vue {
  @Prop({required: true})
  public nutritionInformations!: ServingNutritionDto[];

  public nutritionFactTypes = [
    {
      key: 'ENERGY',
    },
    {
      key: 'FAT',
      children: ['FASAT', 'FAMSCIS', 'FAPUCIS'],
    },
    {
      key: 'CHOAVL',
      children: ['POLYL', 'STARCH', 'SUGAR-'],
    },
    {
      key: 'FIBTG',
    },
    {
      key: 'PRO-',
    },
    {
      key: 'SALTEQ',
    },
  ];

  public unitHeaderLabel(servingNutritionDto: ServingNutritionDto): TranslateResult {
    if (this.isServing(servingNutritionDto)) {
      return this.$t('message.detail.nutrition.header.serving');
    }

    return this.$t('message.detail.nutrition.header.oneHundred');
  }

  public preparedLabel(servingNutritionDto: ServingNutritionDto): TranslateResult {
    if (this.isPrepared(servingNutritionDto)) {
      return this.$t('message.detail.nutrition.header.prepared');
    }

    return this.$t('message.detail.nutrition.header.prepared');
  }

  public isServing(servingNutritionDto: ServingNutritionDto): boolean {
    return servingNutritionDto.header.type === ServingNutritionType.SERVING;
  }

  public isPrepared(servingNutritionDto: ServingNutritionDto): boolean {
    return servingNutritionDto.header.isPrepared;
  }

  public showServingSize(servingNutritionDto: ServingNutritionDto) {
    return this.isServing(servingNutritionDto) && servingNutritionDto.header.servingDescription;
  }

  public servingSizeString(servingNutritionDto: ServingNutritionDto): string | undefined {
    return servingNutritionDto.header.servingDescription;
  }
}
